import { Link } from 'react-router-dom';
import danishFlag from '../images/danishflag.png';
import '../style/navbar.css'

function Navbar() {
    return (
      <nav>
        {/* Danish Flag */}
        <Link to="/" className="flag-container">
          <img src={danishFlag} alt="Danish Flag" className="flag-image" />
          </Link>
        {/* Nav Links */}
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/countries-visited">Countries Visited</Link>
          <Link to="/next-destination">Next Destination</Link>
        </div>
      </nav>
    );
  }
  
  export default Navbar;